module.exports = __webpack_public_path__ + "img/loading.299172eb.gif";